import React, { useState } from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client/react/hooks';
import { FormattedMessage } from 'react-intl';

import ImageView from 'lib/images/image-view';
import btoa from 'lib/base64/btoa';
import atob from 'lib/base64/atob';

import ArrowWidgetButton from '../arrow-widget-button';

import query, { BlogAlbumWidgetQuery, BlogAlbumWidgetQueryVariables } from './blog-album-widget.graphql';
import defaultStyles from './blog-album-widget.scss';

interface Props {
    styles: typeof defaultStyles;
    slug: string;
    username: string;
    label: string;
}

const BlogAlbumWidget: React.FC<Props> = props => {
    const { styles, slug, username, label } = props;

    const [after, setAfter] = useState<null | string>(null);

    const { data } = useQuery<BlogAlbumWidgetQuery, BlogAlbumWidgetQueryVariables>(query, {
        variables: { slug, username, first: 5, after },
        fetchPolicy: 'cache-first',
    });

    const endCursor = data && data.postBySlug && data.postBySlug.images && data.postBySlug.images.pageInfo.endCursor;
    const startCursor =
        data && data.postBySlug && data.postBySlug.images && data.postBySlug.images.pageInfo.startCursor;

    const startIndex = (startCursor && parseInt(atob(startCursor).split(':')[1], 10)) || 0;
    const hasPreviousPage = startIndex > 0;
    const hasNextPage =
        data && data.postBySlug && data.postBySlug.images && data.postBySlug.images.pageInfo.hasNextPage;

    const prevPageAfter = startIndex < 6 ? null : btoa(`arrayconnection:${startIndex - 6}`);

    if (data && data.postBySlug && data.postBySlug.images && data.postBySlug.images.edges) {
        return (
            <div className={styles.widget}>
                <div className={styles.widgetTitle}>{label || data.postBySlug.title}</div>
                <Link to={data.postBySlug.href} className={styles.button}>
                    <FormattedMessage id='COMPLETE_ALBUM' />
                </Link>
                <div className={styles.images}>
                    <ArrowWidgetButton
                        onClick={() => {
                            setAfter(prevPageAfter || null);
                        }}
                        direction='left'
                        hidden={!hasPreviousPage}
                    />
                    {data.postBySlug.images.edges.map(edge =>
                        edge && edge.node ? (
                            <Link to={data!.postBySlug!.href} className={styles.image}>
                                <ImageView aspectFill={true} linkify={false} {...(edge.node.photoFile as any)} />
                            </Link>
                        ) : null
                    )}
                    <ArrowWidgetButton
                        onClick={() => {
                            setAfter(endCursor || null);
                        }}
                        direction='right'
                        hidden={!hasNextPage}
                    />
                </div>
            </div>
        );
    }
    return null;
};

export default Styled(defaultStyles)(BlogAlbumWidget);
